import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Icon } from "../../../Icon";
import styles from "./MenuNav.module.scss";

const MenuNavItem = ({ isOpen, renderMenuLink, menuLink, unmountTrap }) => {
	const [isMenuOpened, setIsMenuOpened] = useState(false);

	const handleSubMenuDropdown = () => {
		setIsMenuOpened(!isMenuOpened);
	};

	// Close sub menu if main menu closes
	useEffect(() => {
		if (!isOpen) {
			setIsMenuOpened(false);
		}
	}, [isOpen]);

	return (
		<li className={styles.item}>
			{menuLink.links ? (
				<>
					{menuLink.displayTitle && (
						<button
							className={styles.dropdownToggle}
							type="button"
							onClick={handleSubMenuDropdown}
							aria-label={menuLink.displayTitle}
							aria-haspopup={true}
							aria-expanded={isMenuOpened}>
							<span>{menuLink.displayTitle}</span>
							<Icon className={styles.accordionChevron} name="arrow-down" />
						</button>
					)}
					<ul
						className={cx(styles.dropdownContainer, isMenuOpened && styles.dropdownContainerOpen)}>
						{menuLink.links.map(nestedLink => (
							<li className={styles.dropdownCategory} key={nestedLink.id}>
								{nestedLink.displayTitle && (
									<p className={styles.dropdownCategoryTitle}>{nestedLink.displayTitle}</p>
								)}
								{renderMenuLink(nestedLink, {
									unmountTrap,
									classNames: {
										link: styles.dropdownCategoryItem,
									},
								})}
							</li>
						))}
					</ul>
				</>
			) : (
				renderMenuLink(menuLink, {
					unmountTrap,
					classNames: { link: styles.link },
				})
			)}
		</li>
	);
};

MenuNavItem.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	renderMenuLink: PropTypes.func,
	menuLink: PropTypes.shape({
		displayTitle: PropTypes.string,
		links: PropTypes.arrayOf(
			PropTypes.shape({
				displayTitle: PropTypes.string,
				links: PropTypes.arrayOf(
					PropTypes.shape({
						id: PropTypes.string,
						linkText: PropTypes.string,
						url: PropTypes.string,
						target: PropTypes.string,
					})
				),
				id: PropTypes.string,
				linkText: PropTypes.string,
				url: PropTypes.string,
				target: PropTypes.string,
			})
		),
		id: PropTypes.string,
		linkText: PropTypes.string,
		url: PropTypes.string,
		target: PropTypes.string,
	}).isRequired,
	unmountTrap: PropTypes.func.isRequired,
};
MenuNavItem.defaultProps = {
	renderMenuLink: (link, { classNames }) => (
		<a href={link.url} target={link.target} className={classNames?.link}>
			{link.linkText}
		</a>
	),
};

export default MenuNavItem;
export { MenuNavItem };
